module.exports = __webpack_public_path__ + "static/media/cross.8c46937d.svg";